import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { postSaga, PostSagaGenericParams } from "../base/request/post";
import { SagaActionParams, SagaGenericParams } from "../base/types/saga";
import { ClientContract, Iyzico3DResponseDto } from "./types";
import { getListSaga } from "../base/request/get";

export const registerAction = createAction(
  "REGISTER_ACTION",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/webadmin/register",
    body,
  })
);
export const startpaymentsecurity = createAction(
  "START_PAYMENT_SECURITY",
  ({ payload, body }: SagaActionParams<Iyzico3DResponseDto>) => ({
    payload,
    url: "/api/webadmin/startpaymentsecurity",
    body,
  })
);
export const purchasedPackagewith3dsecurity = createAction(
  "START_PURCHASED_PACKAGE_3D_SECURITY",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/webadmin/buywith3dsecurity",
    body,
  })
);
export const purchasedPackage = createAction(
  "PURCHASED_PACKAGE",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/webadmin/buy",
    body,
  })
);
export const getSalesAgreement = createAction(
  "GET_SALES_AGREEMENT",
  ({ payload, body }: SagaActionParams<ClientContract[]>) => ({
    payload,
    url: "/api/system/contractsbyrole?roleId=7",
    body,
  })
);
const authSaga = [
  takeLatest(getSalesAgreement.toString(), (payload: SagaGenericParams<any>) =>
    getListSaga<any>(payload)
  ),
  takeLatest(registerAction.toString(), (payload: PostSagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
  takeLatest(
    purchasedPackage.toString(),
    (payload: PostSagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest(
    purchasedPackagewith3dsecurity.toString(),
    (payload: PostSagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest(
    startpaymentsecurity.toString(),
    (payload: PostSagaGenericParams<any>) => postSaga<any>(payload)
  ),
];

export default authSaga;
